import React from 'react';
import MyDocsLibrary from './MyDocsLibrary';

const MyDocsManagerModal = ({
  onClose,
  subject = '',
  grade = '',
  childId = '',
  batchId = '',
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl flex flex-col overflow-hidden"
        style={{ maxHeight: 'min(88vh, 720px)' }}
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-slate-700 to-slate-800 px-5 py-4 flex items-start justify-between flex-shrink-0">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-xl bg-white/15 flex items-center justify-center text-xl">
              📁
            </div>
            <div>
              <h2 className="text-base font-semibold text-white leading-tight">My Documents</h2>
              <p className="text-xs text-white/70 mt-0.5">
                Manage PDFs and images you've uploaded as references
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-white/80 hover:text-white text-2xl sm:text-3xl font-bold w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full hover:bg-white/15 transition-all"
            aria-label="Close"
          >
            <svg className="w-5 h-5 sm:w-6 sm:h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>

        <MyDocsLibrary
          subject={subject}
          grade={grade}
          childId={childId}
          batchId={batchId}
        />

        {/* Footer */}
        <div className="flex items-center justify-end px-4 py-3 border-t border-gray-100 bg-white flex-shrink-0">
          <button
            type="button"
            onClick={onClose}
            className="px-3 py-1.5 text-xs font-medium border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MyDocsManagerModal;
